<template>
  <multiselect
    :multiple="true"
    :options="options"
    :searchable="true"
    :internal-search="false"
    :option-height="104"
    :loading="isSearching"
    :options-limit="50"
    :value="filters"
    track-by="id"
    label="title"
    placeholder="Επιλέξτε φίλτρα με χρήση τίτλου..."
    selected-label="Επιλεγμένο"
    select-label="Πατήστε enter για επιλογή"
    deselect-label="Πατήστε enter για απο-επιλογή"
    class="multiple"
    data-vv-value-path="value"
    data-vv-name="filter"
    @search-change="searchFilters"
    @select="selectFilter"
    @remove="removeFilter"
  >
    <template v-slot:option="props" class="option">
      <div class="option__desc">
        <span class="option__title">{{ props.option.title }}</span>
      </div>
    </template>
    <template v-slot:noResult>
      Δε βρέθηκαν αποτελέσματα. Προσπαθήστε ξανά!!
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _debounce from 'lodash/debounce';
import request from '@/utils/request';
import Photo from '@/views/components/Photo';

export default {
  inject: ['$validator'],
  components: {
    Multiselect,
    Photo,
  },
  props: {
    filters: Array,
  },
  data() {
    return {
      options: [],
      isSearching: false,
    };
  },
  methods: {
    // eslint-disable-next-line func-names
    searchFilters: _debounce(async function(searchQuery) {
      if (searchQuery.length) {
        this.isSearching = true;
        const { data } = await request.get('/filters-search', {
          params: {
            term: searchQuery,
          },
        });
        this.isSearching = false;

        this.options = data.filters;
      }
    }, 300),
    selectFilter(selectedOption) {
      this.$emit('selectFilter', selectedOption);
    },
    removeFilter(selectedOption) {
      this.$emit('removeFilter', selectedOption);
    },
  },
};
</script>

<style scoped lang="scss">
.multiselect {
  margin: 0 auto;
}
</style>
